// tslint:disable: unified-signatures

export function objectFromEntries<K extends string, T>(
    entries: ReadonlyArray<readonly [K, T]>,
): { [key in K]: T };
export function objectFromEntries<K extends string, T>(
    entries: Iterable<readonly [K, T]>,
): { [key in K]: T };
export function objectFromEntries<K extends string, T>(entries: Iterable<readonly [K, T]>) {
    const result: { [P in string]: T } = {};
    for (const [key, value] of entries) {
        result[key] = value;
    }
    return result;
}



// WEBPACK FOOTER //
// ./src/utilidades/objetos.ts